import 'gw-portals-policytransaction-common-angular';
import 'angularRouter';
import RouteConfig from './config/RouteConfig';

import BOPLocationDirective from './locationsAndBuildings/directives/bop-location-directive/BOPLocationDirective';
import BOPLocationHeader from './locationsAndBuildings/directives/bop-location-directive/BOPLocationHeader';

import BOPBuildingDirective from './locationsAndBuildings/directives/bop-building-directive/BOPBuildingDirective';
import BOPBuildingHeader from './locationsAndBuildings/directives/bop-building-directive/BOPBuildingHeader';

import BOPConfirmation from './locationsAndBuildings/directives/bop-confirmation-directive/BOPConfirmationDirective';

import BOPGeneralCoverages from './coverages/general';
import BOPAdditionalCoverages from './coverages/additional';

export default angular.module('gw-portals-bop-components-angular', ['edge.transaction.common.app']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).directive('gwQnbBopLocation', BOPLocationDirective).directive('gwQnbBopBuilding', BOPBuildingDirective).directive('gwQnbBopLocationHeader', BOPLocationHeader).directive('gwQnbBopBuildingHeader', BOPBuildingHeader).directive('gwQnbBopConfirmation', BOPConfirmation).component('gwBopGeneralCoverages', BOPGeneralCoverages).component('gwBopAdditionalCoverages', BOPAdditionalCoverages);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/module.js
// module id = 1814
// module chunks = 0